export default {"src":"/_next/static/media/target.3ad326a5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};